import type * as Types from '../../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { OrValidatorErrorFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/options-registration.graphql';
import { IdentityFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/identity.graphql';
import { VestingOccasionFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/warrant-program-participant.graphql';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/share-class.graphql';
import { FileFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/document.graphql';
import { OptionsSubscriberRepresentativeFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/options-subscriber-representative.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlStepOrSubscribersQueryVariables = Types.Exact<{
  wpId: Types.Scalars['ID']['input'];
  orId: Types.Scalars['ID']['input'];
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlStepOrSubscribersQuery = { optionsRegistrationErrors: { decision: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signatories: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, participants: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signsRegForm: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, payBeforeDate: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, options: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, todos: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } }, optionsRegistration: { id: string, description?: string | null, participants: Array<{ id: string, quantityRepurchased: string, quantity?: string | null, vestedQuantityOnEndDate?: string | null, paymentKind: number, optionsRegistrationId: string, paymentStatus: number, vestingKind: number, vestingCliffDuration: number, vestingDuration: number, vestingFrequency: number, vestingEndDate?: string | null, vestingLastPotentialDate?: string | null, forcedRedemption: boolean, repurchaseVested: boolean, vestingAcceleration: boolean, leaveOfAbsence: boolean, leaveOfAbsenceDays: number, vestingCustomKindPrimaryLang?: string | null, vestingCustomKindSecondaryLang?: string | null, claim?: string | null, createdAt: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, vestingOccasions: Array<{ id: string, warrantParticipantId: string, quantity: string, vestingDate?: string | null, descriptionPrimaryLang?: string | null, descriptionSecondaryLang?: string | null, requirementPrimaryLang?: string | null, requirementSecondaryLang?: string | null, sortOrder: number, isValid: boolean, totalVested?: string | null, status: Types.GqlVestingOccasionStatus }>, shareClass: { name: string, voteWeight: string, quantity?: string | null }, latestAgreementDoc?: { isFullySigned: boolean, id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean } | null, representatives: Array<{ id: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }> }> }, warrantProgram: { name?: string | null, id: string, companyId: string, paymentKindCash: boolean, warrantsForQeso: boolean, warrantKind: Types.GqlWarrantProgramKind, paidForAt?: string | null, usesStepper: boolean, warrantStartDate?: string | null, warrantEndDate?: string | null, maxNumberOfOptions?: string | null, allocated: string, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }>, meetingConcern?: { id: string, meetingId: string } | null, company: { id: string, name: string, email?: string | null, organizationNumber: string, allowShortQeso: boolean } } };

export type GqlCreateOptionsSubscriberRepresentativeMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlOptionsSubscriberRepresentativeCreateInput;
}>;


export type GqlCreateOptionsSubscriberRepresentativeMutation = { createOptionsSubscriberRepresentative: { id: string, identityId: string, warrantParticipantId: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } } };

export type GqlDeleteOptionsSubscriberRepresentativeMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteOptionsSubscriberRepresentativeMutation = { deleteOptionsSubscriberRepresentative: { id: string } };


export const StepOrSubscribersDocument = gql`
    query StepOrSubscribers($wpId: ID!, $orId: ID!, $companyId: ID!) {
  optionsRegistrationErrors(id: $orId, companyId: $companyId) {
    ...OrValidatorErrorFields
  }
  optionsRegistration(id: $orId) {
    id
    description
    participants {
      id
      quantityRepurchased
      identity {
        ...IdentityFields
      }
      vestingOccasions {
        ...VestingOccasionFields
      }
      quantity
      vestedQuantityOnEndDate
      shareClass {
        ...ScFields
      }
      paymentKind
      latestAgreementDoc {
        ...FileFields
        isFullySigned
      }
      representatives {
        id
        identity {
          ...IdentityFields
        }
      }
      optionsRegistrationId
      paymentStatus
      vestingKind
      vestingCliffDuration
      vestingDuration
      vestingFrequency
      vestingEndDate
      vestingLastPotentialDate
      forcedRedemption
      repurchaseVested
      vestingAcceleration
      leaveOfAbsence
      leaveOfAbsenceDays
      vestingCustomKindPrimaryLang
      vestingCustomKindSecondaryLang
      claim
      createdAt
    }
  }
  warrantProgram(id: $wpId) {
    name
    id
    companyId
    paymentKindCash
    warrantsForQeso
    warrantKind
    paidForAt
    usesStepper
    warrantStartDate
    warrantEndDate
    maxNumberOfOptions
    allocated
    shareClasses {
      ...ScWithMinMaxFields
    }
    meetingConcern {
      id
      meetingId
    }
    company {
      id
      name
      email
      organizationNumber
      allowShortQeso
    }
  }
}
    ${OrValidatorErrorFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}
${VestingOccasionFieldsFragmentDoc}
${ScFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${ScWithMinMaxFieldsFragmentDoc}`;

/**
 * __useStepOrSubscribersQuery__
 *
 * To run a query within a React component, call `useStepOrSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepOrSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStepOrSubscribersQuery({
 *   variables: {
 *      wpId: // value for 'wpId'
 *      orId: // value for 'orId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStepOrSubscribersQuery(baseOptions: Apollo.QueryHookOptions<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables> & ({ variables: GqlStepOrSubscribersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>(StepOrSubscribersDocument, options);
      }
export function useStepOrSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>(StepOrSubscribersDocument, options);
        }
export function useStepOrSubscribersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>(StepOrSubscribersDocument, options);
        }
export type StepOrSubscribersQueryHookResult = ReturnType<typeof useStepOrSubscribersQuery>;
export type StepOrSubscribersLazyQueryHookResult = ReturnType<typeof useStepOrSubscribersLazyQuery>;
export type StepOrSubscribersSuspenseQueryHookResult = ReturnType<typeof useStepOrSubscribersSuspenseQuery>;
export type StepOrSubscribersQueryResult = Apollo.QueryResult<GqlStepOrSubscribersQuery, GqlStepOrSubscribersQueryVariables>;
export const CreateOptionsSubscriberRepresentativeDocument = gql`
    mutation CreateOptionsSubscriberRepresentative($companyId: ID!, $input: OptionsSubscriberRepresentativeCreateInput!) {
  createOptionsSubscriberRepresentative(companyId: $companyId, input: $input) {
    ...OptionsSubscriberRepresentativeFields
    identity {
      ...IdentityFields
    }
  }
}
    ${OptionsSubscriberRepresentativeFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export type GqlCreateOptionsSubscriberRepresentativeMutationFn = Apollo.MutationFunction<GqlCreateOptionsSubscriberRepresentativeMutation, GqlCreateOptionsSubscriberRepresentativeMutationVariables>;

/**
 * __useCreateOptionsSubscriberRepresentativeMutation__
 *
 * To run a mutation, you first call `useCreateOptionsSubscriberRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptionsSubscriberRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptionsSubscriberRepresentativeMutation, { data, loading, error }] = useCreateOptionsSubscriberRepresentativeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOptionsSubscriberRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateOptionsSubscriberRepresentativeMutation, GqlCreateOptionsSubscriberRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateOptionsSubscriberRepresentativeMutation, GqlCreateOptionsSubscriberRepresentativeMutationVariables>(CreateOptionsSubscriberRepresentativeDocument, options);
      }
export type CreateOptionsSubscriberRepresentativeMutationHookResult = ReturnType<typeof useCreateOptionsSubscriberRepresentativeMutation>;
export type CreateOptionsSubscriberRepresentativeMutationResult = Apollo.MutationResult<GqlCreateOptionsSubscriberRepresentativeMutation>;
export type CreateOptionsSubscriberRepresentativeMutationOptions = Apollo.BaseMutationOptions<GqlCreateOptionsSubscriberRepresentativeMutation, GqlCreateOptionsSubscriberRepresentativeMutationVariables>;
export const DeleteOptionsSubscriberRepresentativeDocument = gql`
    mutation DeleteOptionsSubscriberRepresentative($companyId: ID!, $id: ID!) {
  deleteOptionsSubscriberRepresentative(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteOptionsSubscriberRepresentativeMutationFn = Apollo.MutationFunction<GqlDeleteOptionsSubscriberRepresentativeMutation, GqlDeleteOptionsSubscriberRepresentativeMutationVariables>;

/**
 * __useDeleteOptionsSubscriberRepresentativeMutation__
 *
 * To run a mutation, you first call `useDeleteOptionsSubscriberRepresentativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionsSubscriberRepresentativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionsSubscriberRepresentativeMutation, { data, loading, error }] = useDeleteOptionsSubscriberRepresentativeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOptionsSubscriberRepresentativeMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteOptionsSubscriberRepresentativeMutation, GqlDeleteOptionsSubscriberRepresentativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteOptionsSubscriberRepresentativeMutation, GqlDeleteOptionsSubscriberRepresentativeMutationVariables>(DeleteOptionsSubscriberRepresentativeDocument, options);
      }
export type DeleteOptionsSubscriberRepresentativeMutationHookResult = ReturnType<typeof useDeleteOptionsSubscriberRepresentativeMutation>;
export type DeleteOptionsSubscriberRepresentativeMutationResult = Apollo.MutationResult<GqlDeleteOptionsSubscriberRepresentativeMutation>;
export type DeleteOptionsSubscriberRepresentativeMutationOptions = Apollo.BaseMutationOptions<GqlDeleteOptionsSubscriberRepresentativeMutation, GqlDeleteOptionsSubscriberRepresentativeMutationVariables>;